import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  private loader$: BehaviorSubject<boolean>;

  private reqUrl = new BehaviorSubject<any>('');
  public loaderMsg = new BehaviorSubject<any>(false);
  public getReqUrl = this.reqUrl.asObservable();

  constructor() {
    this.loader$ = new BehaviorSubject<boolean>(false);
  }

  sentReqUrl(url: any) {
    this.reqUrl.next(url);
  }

  showloaderMsg(msg: any) {
    this.loaderMsg.next(msg);
  }

  public isLoading(): Observable<boolean> {
    return this.loader$;
  }

  public nextLoading(v: boolean): void {
    this.loader$.next(v);
  }
}
